import angular from 'angular';
import uiRouter from 'angular-ui-router';

import storeSelectComponent from './storeSelect.component';
import SearchStore from './search/search';

const storeSelectModule = angular.module('tinaba.common.storeselect', [
    uiRouter,
    SearchStore.name
])

.component('storeSelect', storeSelectComponent);

export default storeSelectModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/storeSelect/storeSelect.js
 **/